import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RendererComponent } from 'src/app/renderer/renderer.component';
import { LandingPagesRoutingModule } from './landing-pages.routing';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        LandingPagesRoutingModule,
        RendererComponent,
    ],
    exports: []
})
export class LandingPagesModule { }
